import { getContent } from '../store/ContentStore';

export const loadEmailFormConstantsEn = () => {
    const content = getContent("email.", "en");

    if (!content || !content.en) {
        return {};
    }

    const english = content.en;

    return {
        messagePlaceholder: english['email.message.placeholder'] || '',
        messageError: english['email.message.error'] || '',
        addressPlaceholder: english['email.address.placeholder'] || '',
        addressError: english['email.address.error'] || '',
        buttonText: english['email.address.button'] || ''
    };
};

export const loadEmailFormConstantsRo = () => {
    const contentRo = getContent("email.", "ro");
    const contentEn = getContent("email.", "en");

    if (!contentRo || !contentRo.ro || !contentEn || !contentEn.en) {
        return {};
    }

    const ro = contentRo.ro;
    const en = contentEn.en;

    return {
        messagePlaceholder: ro['email.message.placeholder'] || en['email.message.placeholder'] || '',
        messageError: ro['email.message.error'] || en['email.message.error'] || '',
        addressPlaceholder: ro['email.address.placeholder'] || en['email.address.placeholder'] || '',
        addressError: ro['email.address.error'] || en['email.address.error'] || '',
        buttonText: ro['email.address.button'] || en['email.address.button'] || ''
    };
};
